import firebase from 'firebase/app'
import 'firebase/firestore';
import 'firebase/database';

var firebaseConfig = {
    apiKey: "AIzaSyBscG06sVUK-2u6JY8gtE5C6Fi4o8_52fU",
    authDomain: "move-it-nq.firebaseapp.com",
    // databaseURL: "https://move-it-nq.firebaseio.com",
    databaseURL: "https://move-it-nq.firebaseio.com/",
    projectId: "move-it-nq",
    storageBucket: "move-it-nq.appspot.com",
    messagingSenderId: "548434561741",
    appId: "1:548434561741:web:cff7c9ef0d05a094c7f784",
    measurementId: "G-3HH2NQS09E"
}
firebase.initializeApp(firebaseConfig);
export default firebase;
// export const db = firebase
//   .initializeApp(firebaseConfig)
//   .firestore()


